import { AppHeader } from 'components/design-system/composites/AppHeader'
import { FullScreenModal } from 'components/organisms/FullScreenModal'
import { LoginArea } from 'components/organisms/LoginArea'

export const LoginTemplate = () => {
  const browserSupported = window.INITIAL_STATE.browserSupported
  return (
    <>
      <AppHeader />
      <LoginArea />
      <FullScreenModal isOpen={!browserSupported} />
    </>
  )
}
